import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Row = styled("label")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  cursor: "pointer",
}));

export const Label = styled(Typography)({
  fontWeight: 500,
});
